import React from "react";
import DateRangeIcon from '@mui/icons-material/DateRange';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';

/* ============================================================
   Notification icons
   ------------------------------------------------------------
   One mapping, used by the notification drawer and the dashboard
   panel. It lived in both files before, so a new kind of
   notification had to be added twice — and Help Desk was only
   ever added to neither, leaving those rows with a blank circle.

   `title` is what the server sets on the notification.
   ============================================================ */

const ICONS = {
    'Leave Request': { tone: 'bg-warning', Icon: DateRangeIcon },
    'Work Report': { tone: 'bg-primary', Icon: AssignmentIndOutlinedIcon },
    'Project': { tone: 'bg-success', Icon: AccountTreeIcon },
    'Interview': { tone: 'bg-secondary', Icon: PersonSearchIcon },
    'Help Desk': { tone: 'bg-info', Icon: SupportAgentOutlinedIcon },
};

/* anything unrecognised still gets a circle rather than a gap */
const FALLBACK = { tone: 'bg-primary', Icon: NotificationsNoneRoundedIcon };

export const notificationIcon = (title) => {
    const { tone, Icon } = ICONS[title] || FALLBACK;

    return (
        <div className={`rounded-circle ${tone} d-flex justify-content-center align-items-center p-2`}>
            <Icon className="text-white" />
        </div>
    );
};

export default notificationIcon;
